var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAntDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9512 1.24291L1.23838 31.9305C-0.412793 33.5803 -0.412793 36.245 1.23838 37.8948L31.9512 68.5824C33.6024 70.2322 36.2693 70.2322 37.9205 68.5824L50.7979 55.7155C52.2766 54.238 52.2766 51.8424 50.7979 50.3649C49.3192 48.8874 46.9216 48.8874 45.4429 50.3649L35.6806 60.1192C35.2696 60.5298 34.6459 60.5298 34.2349 60.1192L9.70855 35.613C9.29757 35.2023 9.29757 34.5791 9.70855 34.1685L34.2349 9.66227C34.6459 9.25163 35.2696 9.25163 35.6806 9.66227L45.4429 19.4165C46.9216 20.8941 49.3192 20.8941 50.7979 19.4165C52.2766 17.939 52.2766 15.5435 50.7979 14.0659L37.9219 1.20047C36.2639 -0.413644 33.596 -0.400577 31.9512 1.24291Z",
    fill: "url(#paint0_linear_1930_22369)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9512 1.24291L1.23838 31.9305C-0.412793 33.5803 -0.412793 36.245 1.23838 37.8948L31.9512 68.5824C33.6024 70.2322 36.2693 70.2322 37.9205 68.5824L50.7979 55.7155C52.2766 54.238 52.2766 51.8424 50.7979 50.3649C49.3192 48.8874 46.9216 48.8874 45.4429 50.3649L35.6806 60.1192C35.2696 60.5298 34.6459 60.5298 34.2349 60.1192L9.70855 35.613C9.29757 35.2023 9.29757 34.5791 9.70855 34.1685L34.2349 9.66227C35.2582 8.78008 36.9279 6.99322 39.3798 6.57531C41.202 6.26472 43.1941 6.94832 45.3562 8.62609C43.9107 7.18177 41.4326 4.70656 37.9219 1.20047C36.2639 -0.413644 33.596 -0.400577 31.9512 1.24291Z",
    fill: "url(#paint1_linear_1930_22369)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.771 47.511C55.2498 48.9885 57.6473 48.9885 59.126 47.511L68.6251 38.0198C70.2762 36.37 70.2762 33.7052 68.6253 32.0556L59.0434 22.5156C57.5612 21.0398 55.1629 21.0419 53.6833 22.5204C52.2045 23.9979 52.2045 26.3934 53.6833 27.871L60.1549 34.3373C60.5659 34.7479 60.5659 35.3711 60.1549 35.7818L53.771 42.1604C52.2923 43.6379 52.2923 46.0335 53.771 47.511Z",
    fill: "url(#paint2_linear_1930_22369)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0893 43.3516C39.6691 43.3516 43.3818 39.6419 43.3818 35.0659C43.3818 30.4899 39.6691 26.7803 35.0893 26.7803C30.5095 26.7803 26.7969 30.4899 26.7969 35.0659C26.7969 39.6419 30.5095 43.3516 35.0893 43.3516Z",
    fill: "url(#paint3_linear_1930_22369)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1930_22369",
    x1: 3223.54,
    y1: 0.000172609,
    x2: 6142.15,
    y2: 1782.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1930_22369",
    x1: 3615.01,
    y1: -0.0000397681,
    x2: 2173.49,
    y2: 7450.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378601,
    stopColor: "#148EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A60FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1930_22369",
    x1: 1257.48,
    y1: -331.609,
    x2: -618.169,
    y2: 2601.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA816E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414726,
    stopColor: "#F74A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F51D2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1930_22369",
    x1: 1156.69,
    y1: -564.658,
    x2: 532.611,
    y2: 1931.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512635,
    stopColor: "#F74A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F51D2C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntDesign);
export default __webpack_public_path__ + "static/media/ant_design.fe53bf25dd9dd4b31f49257fa501c6a9.svg";
export { ForwardRef as ReactComponent };